var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResultsTable',{attrs:{"fields":_vm.tableFields,"results":_vm.tableData},on:{"toggleItem":_vm.listToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }